<template>
  <b-button variant="success" class="btn-icon-text" style="white-space: nowrap" @click="addBox">
    <i class="mdi mdi-server-plus btn-icon-prepend m-0"></i>
    <span v-if="!light">{{ $t('header.buttons.addBox') }}</span>
  </b-button>
</template>

<script>
export default {
  name: 'BoxAddButton',
  props: {
    light: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    addBox() {
      if (this.$store.getters.isAdmin) {
        this.$router.push({
          name: 'SettingsAddBox',
        });
      } else {
        this.$bvModal
          .msgBoxConfirm(this.$t('addBox.modal.body'), {
            title: this.$t('addBox.modal.title'),
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'primary',
            headerBgVariant: 'danger',
            okTitle: this.$t('addBox.modal.createOrgBtn'),
            cancelTitle: this.$t('button.cancel.label'),
            headerClass: 'p-2 border-bottom-1',
            footerClass: 'p-1 border-top-0',
            centered: true,
            headerTextVariant: 'light',
            bodyBgVariant: 'dark',
            bodyTextVariant: 'light',
            footerBgVariant: 'dark',
          })
          .then((result) => {
            if (result) {
              this.$router.push({
                name: 'SmartOeeRegisterCompany',
              });
            }
          });
      }
    },
  },
};
</script>

<style></style>
